﻿
import ImageZoom from './imageZoom';

var productImage = undefined;
var productImages = undefined;
var zoomImage = undefined;
let imageYOffset = undefined;
let firstHover = undefined;
let zoomPreview = undefined;

const initProductImageZoom = (slideActiveImage) => {
    if (window.innerWidth > 767) {
        var activeImage = slideActiveImage
        if (activeImage == undefined) {
            activeImage = document.getElementsByClassName('productImageSlide swiper-slide-active')[0]?.getElementsByTagName('img')[0];
            if (activeImage == undefined) {
                activeImage = document.getElementsByClassName('productImageSlide')[0]?.getElementsByTagName('img')[0];
            }
        }

        if (activeImage == undefined) {
            return;
        }

        let zoomUrl = activeImage.getAttribute("data-zoom-src");
        if (zoomUrl == undefined) {
            zoomUrl = activeImage.getAttribute("src");
        }

        var imageContainer = document.querySelector('#productImageContainer');
        return new ImageZoom(activeImage.parentElement, {
            width: imageContainer.clientWidth,
            height: imageContainer.clientWidth,
            zoomWidth: 500,
            zoomHeight: 500,
            img: zoomUrl,
            zoomedImg: document.getElementById('zoomImage')
        });
    }
};

export default initProductImageZoom;